import { SubmissionError } from "redux-form";
import { apiCallAsync } from "components/shared/api";

export const ActionTypes = {
  EditSuccess: "PROFILE.EDIT.SUCCESS",
  LoadSuccess: "PROFILE.LOAD.SUCCESS",
};

// The form is initialised from the whole /auth/current-user response, so its
// values carry id, role, emailConfirmed, createdAt and updatedAt alongside the
// editable fields. The platform API rejects unknown properties outright, so send
// only what update-user accepts — which is also the safer shape, since a client
// has no business posting its own role back.
const EDITABLE_PROFILE_FIELDS = [
  "firstname",
  "lastname",
  "username",
  "email",
  "street",
  "city",
  "state",
  "zip",
  "country",
  "organization",
  "position",
  "industry",
];

export const editAction = async (data) => {
  try {
    const body = {};
    EDITABLE_PROFILE_FIELDS.forEach((field) => {
      if (data && data[field] !== undefined) body[field] = data[field];
    });
    const r = await apiCallAsync("/auth/update-user", body, "PUT");
    return { type: ActionTypes.EditSuccess, payload: r };
  } catch (ex) {
    let err = "Unknown error";
    try {
      err = JSON.parse(ex.message).message;
    } catch (ex2) {}
    throw new SubmissionError({
      _error: err,
    });
  }
};

export const loadAction = async () => {
  try {
    const r = await apiCallAsync("/auth/current-user", null, "GET");
    console.log(r);
    return { type: ActionTypes.LoadSuccess, payload: { formValues: r } };
  } catch (ex) {
    let err = "Unknown error";
    try {
      err = JSON.parse(ex.message).message;
    } catch (ex2) {}
    throw new SubmissionError({
      _error: err,
    });
  }
};
